import React from 'react';
import {Row, Col} from "react-bootstrap"
import NumberInput from './lib/numberinput'
import Knob from './lib/knob'
import Toggle from './lib/toggle'
import Text from './lib/text'
import {Stage, Layer, Circle, Shape} from 'react-konva';
//import Konva from 'konva';
import GeneticImage from './GeneticImage';
import SuperCurvePainter from './SuperCurvePainter';
import Label from "./lib/label";

class SuperGenetic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      x: 0,
      y: 0,
      g0: 7,
      g1: -1,
      g2: -1,
      g3: -1,
      g4: -1,
      g5: -1,
      g6: -1,
      g7: -1,
      zoom: 5,
      offx: 0,
      offy: 0,
      m1: 1,
      m2: 1,
      n1: 1,
      n2: 1,
      n3: 1,
      a: 1,
      b: 1,
      rot: 0,
      rx: 0.5,
      ry: 0.5,
      warncolor:"#253040"
    };
    this.h = props.def.height;
    this.w = props.def.width;
    const size = 50;
    this.gfuncs = [
      {id: 'g0', type: 'spinner', size: 1, min: -1, max: 33, step: 1, precision: 0, defval: 7, osc:this.props.def.osc},
      {id: 'g1', type: 'spinner', size: 1, min: -1, max: 33, step: 1, precision: 0, defval: -1, osc:this.props.def.osc},
      {id: 'g2', type: 'spinner', size: 1, min: -1, max: 33, step: 1, precision: 0, defval: -1, osc:this.props.def.osc},
      {id: 'g3', type: 'spinner', size: 1, min: -1, max: 33, step: 1, precision: 0, defval: -1, osc:this.props.def.osc},
      {id: 'g4', type: 'spinner', size: 1, min: -1, max: 33, step: 1, precision: 0, defval: -1, osc:this.props.def.osc},
      {id: 'g5', type: 'spinner', size: 1, min: -1, max: 33, step: 1, precision: 0, defval: -1, osc:this.props.def.osc},
      {id: 'g6', type: 'spinner', size: 1, min: -1, max: 33, step: 1, precision: 0, defval: -1, osc:this.props.def.osc},
      {id: 'g7', type: 'spinner', size: 1, min: -1, max: 33, step: 1, precision: 0, defval: -1, osc:this.props.def.osc},
    ];
    this.zoomKnob = {id: 'zoom', type: 'knob', label: 'zoom', min: 0.1, max: 20, step: 0.1, defval: 5, width:size, height:size};
    this.m1 = {id: 'm1', type: 'knob', label: 'm1', min: 0, max: 40, step: 1, defval: 1, width:size, height:size};
    this.m2 = {id: 'm2', type: 'knob', label: 'm2', min: 0, max: 40, step: 1, defval: 1, width:size, height:size};
    this.n1 = {id: 'n1', type: 'knob', label: 'n1', min: -10, max: 10, step: 0.001, defval: 1, width:size, height:size, digits:5};
    this.n2 = {id: 'n2', type: 'knob', label: 'n2', min: -10, max: 10, step: 0.001, defval: 1, width:size, height:size, digits:5};
    this.n3 = {id: 'n3', type: 'knob', label: 'n3', min: -10, max: 10, step: 0.001, defval: 1, width:size, height:size, digits:5};
    this.a = {id: 'a', type: 'knob', label: 'a', min: -10, max: 10, step: 0.001, defval: 1, width:size, height:size, digits:5};
    this.b = {id: 'b', type: 'knob', label: 'b', min: -10, max: 10, step: 0.001, defval: 1, width:size, height:size, digits:5};
    this.rx = {id: 'rx', type: 'knob', label: 'rx', min: 0, max: 4, step: 0.01, defval: 0.5, width:size, height:size, digits:4};
    this.ry = {id: 'ry', type: 'knob', label: 'ry', min: 0, max: 4, step: 0.01, defval: 0.5, width:size, height:size,digits:4};
    this.rot = {id: 'rot', type: 'knob', label: 'rot', min: 0, max: 6.28, step: 0.01, defval: 0, width:size, height:size};
    this.stereo = {id: 'stereo', type:'toggle', label:"stereo",defval: 0, osc:this.props.def.osc}
    this.props.def.changeValue = this.setValue.bind(this);
    const t = `Be careful with non closed curves displayed<br/> in red as they may lead to unexpected behaviour. 
               <br/>TIP: set n1 to a negative value on those curves.<br/> Also pay attention with small values for n1`
    this.text = { id: "text", type: "text", text: t }
    let self = this;
    this.components = {
      g0: self.gfuncs[0],
      g1: self.gfuncs[1],
      g2: self.gfuncs[2],
      g3: self.gfuncs[3],
      g4: self.gfuncs[4],
      g5: self.gfuncs[5],
      g6: self.gfuncs[6],
      g7: self.gfuncs[7],
      m1: self.m1,
      m2: self.m2,
      n1: self.n1,
      n2: self.n2,
      n3: self.n3,
      a: self.a,
      b: self.b,
      rx: self.rx,
      ry: self.ry,
      rot: self.rot,
      stereo: self.stereo,
    }
    Object.values(this.components).forEach( component => component.tooltip=this.computeTooltip(component));
  }

  computeTooltip(elem) {
    return (elem.tooltip?elem.tooltip:'')
      + (elem.midictrl?' ctrl:'+elem.midictrl:'')
      + (this.props.def.osc? ' osc:/'+this.props.def.osc+'/'+this.props.def.id+'/'+elem.id:'')
  }

  componentDidMount() {
    this.canvas = document.createElement('canvas');
    this.canvas.width = this.w;
    this.canvas.height = this.h;
    this.genImg = new GeneticImage(this.canvas);
    this.curvePainter = new SuperCurvePainter();
  }

  updateImage() {
    this.genImg.updateImage([this.state.g0, this.state.g1, this.state.g2, this.state.g3, this.state.g4, this.state.g5, this.state.g6, this.state.g7], this.state.offx, this.state.offy, this.state.zoom);
  }

  round(val) {
    return Math.round(val * 1000) / 1000;
  }

  toPixX(valX) {
    let ret = (valX / (this.state.zoom / 2)) * (this.w / 2) + this.w / 2;
    return ret;
  }

  toPixY(valY) {
    let ret = (valY / (this.state.zoom / 2)) * (this.h / 2) + this.h / 2;
    return ret;
  }

  fromPixX(x) {
    return (x - this.w / 2) / (this.w / 2) * (this.state.zoom / 2);
  }

  fromPixY(y) {
    return (y - this.h / 2) / (this.h / 2) * (this.state.zoom / 2);
  }

  setY(y) {
    this.props.onChange(this.props.def.id, {y: this.round(-y)});
    this.setState({y: y});
    this.circle.y(this.toPixY(y));
  }

  setX(x) {
    this.props.onChange(this.props.def.id, {x: this.round(x)});
    this.setState({x: x});
    this.circle.x(this.toPixX(x));
  }

  setValue(val) {
    Object.keys(val).forEach(key => {
      if (key === 'x') this.setX(val[key]);
      else if (key === 'y') this.setY(-val[key]);
      else {
        if (this.components[key]) {
          if (this.components[key].changeValue)
            this.components[key].changeValue(val[key])
          else
            console.log("component ", key, " has no changeValue")
        } else {
          console.log("component for", key, " not found")
        }
      }
    });
  }

  drag() {
    let x = this.fromPixX(this.circle.attrs.x);
    let y = this.fromPixY(this.circle.attrs.y);
    this.setState({x: x, y: y})
    //this.props.onChange('y', this.round(-y));
    //this.props.onChange('x', this.round(x));
    this.props.onChange(this.props.def.id, {'x': this.round(x), y: this.round(-y)});
  }

  dragCanvas(e) {
    this.setState({offx: this.stage.attrs.x, offy: this.stage.attrs.y});
  }

  check(m1,m2,n1) {
    if(n1<0) return false;
    for(let n=1;n<40;n++) {
      let d = n*2*m1;
      let d1 = d/m2;
      if(Number.isInteger(d1)) {
        if(d1%2!==0) return true;
      }
    }
    return false;
  }

  onChange(id, val) {
    this.props.onChange(this.props.def.id, {[id]: val});
    let obj = {};
    obj[id] = val;
    this.setState(obj,() => {
      if(id === 'm1' || id === 'm2'|| id==='n1') {
        if(this.check(this.state.m1,this.state.m2,this.state.n1)) {
          this.setState({ warncolor: "#AA2222"});
        } else {
          this.setState({warncolor:'#253040'});
        }
      }
    });
  }

  render() {
    return (
      <Col xs="auto" style={{ marginRight:20}}>
        <Row style={{flexWrap: 'wrap'}}>
          <Col xs="auto">
            <Row>
              <Label tooltip={'osc:/'+this.props.def.osc+'/'+this.props.def.id+'/'+'x'} label="x:"/>
              <Col>{this.round(this.state.x)}</Col>
              <Label tooltip={'osc:/'+this.props.def.osc+'/'+this.props.def.id+'/'+'y'} label="y:"/>
              <Col>{this.round(-this.state.y)}</Col>
            </Row>
            <Row noGutters>
              <Col style={{backgroundColor: '#FDF6E3'}}>
                <Stage x={0} y={0} width={this.w} height={this.h} draggable onDragMove={this.dragCanvas.bind(this)}
                       ref={ref => (this.stage = ref)}>
                  <Layer>
                    <Shape x={-this.state.offx} y={-this.state.offy} sceneFunc={(context, shape) => {
                      if (this.canvas) {
                        this.updateImage();
                        context.drawImage(this.canvas, 0, 0);
                      }
                    }}>
                    </Shape>
                  </Layer>
                  <Layer>
                    <Shape stroke="white" strokeWith={3} sceneFunc={(context, shape) => {
                      if (this.canvas) {
                        this.curvePainter.drawCurve(context, shape, this.state.x, this.state.y, this.w, this.h,
                          this.state.zoom, this.state.m1, this.state.m2, this.state.n1, this.state.n2, this.state.n3,
                          this.state.a, this.state.b, this.state.rot, this.state.rx, this.state.ry);
                      }
                    }}>
                    </Shape>
                  </Layer>
                  <Layer>
                    <Circle onDragMove={this.drag.bind(this)} ref={ref => (this.circle = ref)}
                            x={this.toPixX(this.state.x)} y={this.toPixY(this.state.y)} radius={5} fill='rgb(0,68,238)'
                            draggable>
                    </Circle>
                  </Layer>
                </Stage>
              </Col>
            </Row>
          </Col>
          <Col xs="auto">
            <Row className="patlabel"><Col>Terrains</Col></Row>
            <Row noGutters><NumberInput vertical={false} def={this.gfuncs[0]} key={this.gfuncs[0].id}
                                             onChange={this.onChange.bind(this)}/></Row>
            <Row noGutters><NumberInput vertical={false} def={this.gfuncs[1]} key={this.gfuncs[1].id}
                                             onChange={this.onChange.bind(this)}/></Row>
            <Row noGutters><NumberInput vertical={false} def={this.gfuncs[2]} key={this.gfuncs[2].id}
                                             onChange={this.onChange.bind(this)}/></Row>
            <Row noGutters><NumberInput vertical={false} def={this.gfuncs[3]} key={this.gfuncs[3].id}
                                             onChange={this.onChange.bind(this)}/></Row>
            <Row noGutters><NumberInput vertical={false} def={this.gfuncs[4]} key={this.gfuncs[4].id}
                                             onChange={this.onChange.bind(this)}/></Row>
            <Row noGutters><NumberInput vertical={false} def={this.gfuncs[5]} key={this.gfuncs[5].id}
                                             onChange={this.onChange.bind(this)}/></Row>
            <Row noGutters><NumberInput vertical={false} def={this.gfuncs[6]} key={this.gfuncs[6].id}
                                             onChange={this.onChange.bind(this)}/></Row>
            <Row noGutters><NumberInput vertical={false} def={this.gfuncs[7]} key={this.gfuncs[7].id}
                                             onChange={this.onChange.bind(this)}/></Row>
            <Row noGutters><Knob def={this.zoomKnob} key={this.zoomKnob.id}
                                      onChange={this.onChange.bind(this)}/></Row>
            <Row noGutters><Toggle def={this.stereo} key={this.stereo.id} onChange={this.onChange.bind(this)}/></Row>
          </Col>
          <Col xs="auto">
            <Row className="patlabel"><Col>Curve</Col></Row>
            <Row style={{flexWrap: 'nowrap', backgroundColor:this.state.warncolor}}>
              <Knob def={this.m1} key={this.m1.id} onChange={this.onChange.bind(this)}/>
              <Knob def={this.m2} key={this.m2.id} onChange={this.onChange.bind(this)}/>
              <Knob def={this.n1} key={this.n1.id} onChange={this.onChange.bind(this)}/>
            </Row>
            <Row style={{flexWrap: 'nowrap'}}>
              <Knob def={this.n2} key={this.n2.id} onChange={this.onChange.bind(this)}/>
              <Knob def={this.n3} key={this.n3.id} onChange={this.onChange.bind(this)}/>
              <Col> </Col>
            </Row>
            <Row style={{flexWrap: 'nowrap'}}>
              <Knob def={this.a} key={this.a.id} onChange={this.onChange.bind(this)}/>
              <Knob def={this.b} key={this.b.id} onChange={this.onChange.bind(this)}/>
              <Col> </Col>
            </Row>
            <Row style={{flexWrap: 'nowrap'}}>
              <Knob def={this.rx} key={this.rx.id} onChange={this.onChange.bind(this)}/>
              <Knob def={this.ry} key={this.ry.id} onChange={this.onChange.bind(this)}/>
              <Knob def={this.rot} key={this.rot.id} onChange={this.onChange.bind(this)}/>
            </Row>
            <Row><Col><Text def={this.text}/> </Col></Row>
          </Col>
        </Row>
      </Col>
    )
  }

}

export default SuperGenetic;
